import { WLOfferListShortFragment, WLOfferListViewFragment } from '__generated__/graphql';
import { SUBSCRIPTION_OFFER_CHANGED_DETAILS, SUBSCRIPTION_OFFER_CHANGED_SHORT } from './gql';
import { useSubscription } from '@apollo/client';

type SubscribeToOfferChangeShortProps = {
  offer: WLOfferListShortFragment;
  onChanged?: (offer: WLOfferListShortFragment) => void;
  children?: (offer: WLOfferListShortFragment) => React.ReactNode;
};

export function SubscribeToOfferChangeShort({ offer, onChanged, children }: SubscribeToOfferChangeShortProps) {
  const { data, loading } = useSubscription(SUBSCRIPTION_OFFER_CHANGED_SHORT, {
    variables: { offerId: offer.id },
    onData: ({ data }) => {
      if (onChanged && data.data?.offerChanged) onChanged(data.data!.offerChanged);
    },
  });

  if (children) {
    if (loading || !data || !data.offerChanged) {
      return children(offer);
    } else {
      return children(data!.offerChanged!);
    }
  }
  return null;
}

type SubscribeToOfferChangeDetailsProps = {
  offer: WLOfferListViewFragment;
  onChanged?: (offer: WLOfferListViewFragment) => void;
  children?: (offer: WLOfferListViewFragment) => React.ReactNode;
};

export function SubscribeToOfferChangeDetails({ offer, onChanged, children }: SubscribeToOfferChangeDetailsProps) {
  const { data, loading } = useSubscription(SUBSCRIPTION_OFFER_CHANGED_DETAILS, {
    variables: { offerId: offer.id },
    onData: ({ data }) => {
      if (onChanged && data.data?.offerChanged) onChanged(data.data!.offerChanged);
    },
  });

  if (children) {
    if (loading || !data || !data.offerChanged) {
      return children(offer);
    } else {
      return children(data!.offerChanged!);
    }
  }
  return null;
}

type SubscribeToOfferChangeProps = {
  offerId: number;
  onChanged?: () => void;
};

export function SubscribeToOfferChange({ offerId, onChanged }: SubscribeToOfferChangeProps) {
  const { data, loading } = useSubscription(SUBSCRIPTION_OFFER_CHANGED_SHORT, {
    variables: { offerId },
    onData: ({ data }) => {
      if (onChanged && data.data?.offerChanged) onChanged();
    },
  });
  return null;
}
